export const getConfig = () => {
  const hostName = window.location.hostname;

  const config = {
    token: "db19a737384298024ac9c0b9b7a3f7b9b6c0c228",
    locationId: "68ee4ba14430cc2e0f3e4289",
    SCRIPT_URL: "https://stg.matador.ai",
    integratedCtaCss: "https://chat.stg.matador.ai/widget/index.css",
    integratedCtaJs: "https://chat.stg.matador.ai/widget/index.js",
    gaId: "G-ZG5GPEK7H4",
  };

  if (hostName === "localhost") {
    config.SCRIPT_URL = "http://localhost:3000";
    config.integratedCtaCss = "http://localhost:1234/index.css";
    config.integratedCtaJs = "http://localhost:1234/index.js";
  }

  if (hostName === "chat.matador.ai") {
    config.token = "ae191c3bab6cf8300f2c3865398b6c9923753fe6";
    config.locationId = "625e8d44c463d10012fbeaef";
    config.SCRIPT_URL = "https://app.matador.ai";
    config.integratedCtaCss = "https://chat.matador.ai/widget/index.css";
    config.integratedCtaJs = "https://chat.matador.ai/widget/index.js";
  }

  const parsedUrl = new URL(window.location.href);
  const token = parsedUrl.searchParams.get("token");
  const locationId = parsedUrl.searchParams.get("locationId");
  const gaId = parsedUrl.searchParams.get("gaId");

  if (token) {
    config.token = token;
  }

  if (locationId) {
    config.locationId = locationId;
  }

  if (gaId) {
    config.gaId = gaId;
  }

  return config;
};

const {
  SCRIPT_URL,
  token,
  locationId,
  integratedCtaCss,
  integratedCtaJs,
  gaId,
} = getConfig();

const addMatadorConnectScript = () => {
  if (window.matadorLiveChatWidget) {
    return;
  }

  const script = document.createElement("script");
  script.innerHTML = `
      (function(d, t) {
        var g = d.createElement(t), s = d.getElementsByTagName(t)[0];
        g.src = "${SCRIPT_URL}/_livechat.js";
        g.async = true;
        s.parentNode.insertBefore(g, s);
        g.onload = function() {
          matadorLiveChatWidget("${token}");
        }
      })(document, "script");
    `;
  document.body.appendChild(script);
};

const loadMatadorTextMeWidget = () => {
  if (window.matadorTextMeWidget) {
    return;
  }
  (function (d, t) {
    var g = d.createElement(t),
      s = d.getElementsByTagName(t)[0];
    g.src = `${SCRIPT_URL}/_call.js`;
    g.async = true;
    s.parentNode.insertBefore(g, s);
    g.onload = function () {
      window.matadorTextMeWidget(locationId);
    };
  })(document, "script");
};

const loadMatadorCouponWidget = () => {
  if (window.matadorCouponWidget) {
    return;
  }
  (function (d, t) {
    var g = d.createElement(t),
      s = d.getElementsByTagName(t)[0];
    g.src = `${SCRIPT_URL}/_coupon.js`;
    g.async = true;
    s.parentNode.insertBefore(g, s);
    g.onload = function () {
      window.matadorCouponWidget(locationId);
    };
  })(document, "script");
};

const addIntegratedCtaResources = () => {
  let resourcesAdded = false;

  if (!document.querySelector(`link[href="${integratedCtaCss}"]`)) {
    const linkElement = document.createElement("link");
    linkElement.rel = "stylesheet";
    linkElement.href = integratedCtaCss;
    document.head.appendChild(linkElement);
    resourcesAdded = true;
  }

  if (!document.querySelector(`script[src="${integratedCtaJs}"]`)) {
    const scriptElement = document.createElement("script");
    scriptElement.src = integratedCtaJs;
    document.body.appendChild(scriptElement);
    resourcesAdded = true;
  }

  return resourcesAdded;
};

const loadSubscriberGrowthWidget = () => {
  if (window.subscriberGrowth) {
    return;
  }
  (function (d, t) {
    var g = d.createElement(t),
      s = d.getElementsByTagName(t)[0];
    g.src = `${SCRIPT_URL}/_subscriber-growth.js`;
    g.async = true;
    s.parentNode.insertBefore(g, s);
    g.onload = function () {
      // eslint-disable-next-line no-undef
      subscriberGrowth(locationId);
    };
  })(document, "script");
};

export const addGoogleAnalyticsScript = () => {
  if (
    window.gtag ||
    document.querySelector(
      `script[src="https://www.googletagmanager.com/gtag/js?id=${gaId}"]`
    )
  ) {
    return;
  }

  const script1 = document.createElement("script");
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
  script1.async = true;
  document.head.appendChild(script1);

  const script2 = document.createElement("script");
  script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${gaId}');
    `;
  document.head.appendChild(script2);
};

export const addAllWidgetsScripts = () => {
  addMatadorConnectScript();
  addGoogleAnalyticsScript();
  loadMatadorTextMeWidget();
  loadMatadorCouponWidget();
  addIntegratedCtaResources();
  loadSubscriberGrowthWidget();
};
